/*
 * @Author: g05047
 * @Date: 2021-03-04 09:05:50
 * @LastEditors: g05047
 * @LastEditTime: 2021-03-12 15:54:35
 * @Description: file content
 */
export default class fvLineCompute {
    constructor() {
    }


    //风格角度转线性渐变
    static angleToPoints(direction) {
        var pointOfAngle = function (a) {
            return {
                x: Math.cos(a),
                y: Math.sin(a)
            };
        }

        var degreesToRadians = function (d) {
            return ((d * Math.PI) / 180);
        }

        var eps = Math.pow(2, -52);
        var angle = (direction % 360);
        var startPoint = pointOfAngle(degreesToRadians(180 - angle));
        var endPoint = pointOfAngle(degreesToRadians(360 - angle));

        if (startPoint.x <= 0 || Math.abs(startPoint.x) <= eps) {

            startPoint.x = 0;

        }

        if (startPoint.y <= 0 || Math.abs(startPoint.y) <= eps)
            startPoint.y = 0;

        if (endPoint.x <= 0 || Math.abs(endPoint.x) <= eps)
            endPoint.x = 0;

        if (endPoint.y <= 0 || Math.abs(endPoint.y) <= eps)
            endPoint.y = 0;
        return {
            x1: Math.round(startPoint.x),
            y1: Math.round(startPoint.y),
            x2: Math.round(endPoint.x),
            y2: Math.round(endPoint.y)
        };
    }
    //拼接数组
    static merge4(arr) {
        const result = []
        for (let i = 0; i < arr.length; i++) {
            for (let j = 0; j < arr[i].length; j++) {
                result.push(arr[i][j])
            }
        }
        return result;
    }
    /**
     * 径向渐变方法
     */
    //重复次数
    static fcAddColorStop(id, config, i) {
        var beginColor = config.color[1].colorRgb();
        var endColor = config.color[0].colorRgb();
        if (config.spot && config.spot.length != 0) {
            // spot点和color对应正好相反，排序矫正对应
            // config.spot.sort(function (a, b) {
            //     return b - a;
            // });
            config.color.reverse();
            // document.getElementById(id).innerHTML +=`<stop offset="0" stop-color="${config.color[0]}" fill-opacity="${config.transparent[0] / 255}"></stop>`
            for (var j = 0; j < config.spot.length; j++) {
                    var aLi = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
                    aLi.setAttribute("offset", parseFloat(config.spot[j]));
                    aLi.setAttribute("stop-color", config.color[j]);
                    aLi.setAttribute("fill-opacity", config.transparent[j] / 255);
                    document.getElementById(id).appendChild(aLi);
            }
            // document.getElementById(id).innerHTML +=`<stop offset="1" stop-color="${config.color[config.color.length-1]}" fill-opacity="${config.transparent[config.color.length-1] / 255}"></stop>`
        } else {
            if(config.cycletimes>1){
                var aLi = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
                aLi.setAttribute("offset", (2 * (i - 1)) / (2 * config.cycletimes - 1));
                aLi.setAttribute("stop-color", "rgb(" + endColor + ")");
                aLi.setAttribute("fill-opacity", config.transparent[1] / 255);
                document.getElementById(id).appendChild(aLi);
                var str = `<stop offset="${(2 * i - 1) / (2 * config.cycletimes - 1)}" stop-color="rgb(${beginColor})" fill-opacity="${config.transparent[0] / 255}"></stop>`
                document.getElementById(id).innerHTML += str;
            }else{
                var aLi = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
                aLi.setAttribute("offset", (2 * (i - 1)) / (2 * config.cycletimes - 1));
                aLi.setAttribute("stop-color", "rgb(" + beginColor + ")");
                aLi.setAttribute("fill-opacity", config.transparent[1] / 255);
                document.getElementById(id).appendChild(aLi);
                var str = `<stop offset="${(2 * i - 1) / (2 * config.cycletimes - 1)}" stop-color="rgb(${endColor})" fill-opacity="${config.transparent[0] / 255}"></stop>`
                document.getElementById(id).innerHTML += str;
            }
           
        }
    }
    
    //计算中心点偏移量
    static centerpoints(rect, config,startPt,endPt){
        startPt.x = startPt.x + config.centerPoint.centerX * (parseFloat(rect.style.width)/2);
        startPt.y = startPt.y + config.centerPoint.centerY * (parseFloat(rect.style.height)/2);
        var x = startPt.x + config.centerPoint.centerX * (parseFloat(rect.style.width)/2);
        var y = startPt.y + config.centerPoint.centerY * (parseFloat(rect.style.height)/2);
        var tempR = endPt.r;
        endPt.r = Math.sqrt((x - endPt.x)*(x - endPt.x) + (y - endPt.y)*(y - endPt.y))+1;//+1是确保起始点的坐标在终止点半径以内
        if(endPt.r < tempR){
            endPt.r = tempR;
        }
        startPt.r = endPt.r * config.centerPoint.percentage;
    }
}





// WEBPACK FOOTER //
// ./src/js/div/fvLineCompute.js